module.exports = __webpack_public_path__ + "media/bgm_main_en.8f551f99.m4a";